import styled from 'styled-components';
import React from 'react';
import { Container } from '../../styles/variables';
import PageStyledTitle from '../PageStyledTitle';
import Article from '../Article';

// You will work on the blog later.
// You will work on the blog later.
// You will work on the blog later.
const BlogCtn = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 50px;
  
  h5 {
    text-align: center;
    font-weight: normal;
    font-size: 2rem;
    margin-top: 200px;
  }
  `;

function Blog() {
  return (
    <Container id="blog">
      <BlogCtn>
        <PageStyledTitle mClassName="contact-title" title="Blog" />
        <Article />
        {/*  <h5>Great Articles About Ruby, ReactJs & Golang Coming Soon....</h5> */}
        {/*  <h5>Stay tuned 😉</h5> */}
      </BlogCtn>
    </Container>
  );
}

export default Blog;
